import React from "react";
import "../../Styles/yellowcalf.css/Cashless_Balance_Report.css";
import userImg from "../../images/user.png";

function Cashless_Balance_Report() {
  return (
    <div
      className="cashless_balance_report-container"
      style={{ paddingTop: "25px" }}
    >
      {/* Export Buttons */}
      <div className="cashless_balance_report-row">
        <div className="cashless_balance_report-col">
          <div className="cashless_balance_report-panel">
            <div className="cashless_balance_report-panel-body">
              <div className="cashless_balance_report-header">
                <h3 className="cashless_balance_report-title">
                  Cashless Balance Report
                </h3>
                <div className="cashless_balance_report-btn-group">
                  <button
                    data-toggle="dropdown"
                    className="cashless_balance_report-btn-warning"
                  >
                    Export <i className="fa fa-angle-down"></i>
                  </button>
                  <ul className="cashless_balance_report-dropdown-menu">
                    <li>
                      <a
                        href="#"
                        className="cashless_balance_report-export-pdf"
                        data-table="#wallet"
                      >
                        Save as PDF
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        className="cashless_balance_report-export-png"
                        data-table="#wallet"
                      >
                        Save as PNG
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        className="cashless_balance_report-export-csv"
                        data-table="#wallet"
                      >
                        Save as CSV
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        className="cashless_balance_report-export-txt"
                        data-table="#wallet"
                      >
                        Save as TXT
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        className="cashless_balance_report-export-xml"
                        data-table="#wallet"
                      >
                        Save as XML
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        className="cashless_balance_report-export-sql"
                        data-table="#wallet"
                      >
                        Save as SQL
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        className="cashless_balance_report-export-json"
                        data-table="#wallet"
                      >
                        Save as JSON
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        className="cashless_balance_report-export-excel"
                        data-table="#wallet"
                      >
                        Export to Excel
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        className="cashless_balance_report-export-doc"
                        data-table="#wallet"
                      >
                        Export to Word
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        className="cashless_balance_report-export-powerpoint"
                        data-table="#wallet"
                      >
                        Export to PowerPoint
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="cashless_balance_report-row">
        <div className="cashless_balance_report-col">
          <div className="cashless_balance_report-panel">
            <div className="cashless_balance_report-panel-heading">
              <div className="cashless_balance_report-panel-tools"></div>
              <div
                className="cashless_balance_report-status-alert"
                id="status-alert"
              ></div>
            </div>
            <div className="cashless_balance_report-panel-body">
              <div className="cashless_balance_report-table-responsive">
                <table id="wallet" className="cashless_balance_report-table">
                  <thead>
                    <tr className="cashless_balance_report-filters">
                      <td>
                        <input
                          type="text"
                          placeholder="Search Student"
                          className="cashless_balance_report-input"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          placeholder="Search Admission Number"
                          className="cashless_balance_report-input"
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>#</th>
                      <th>Image</th>
                      <th>Student</th>
                      <th>Admission Number</th>
                      <th>Grade</th>
                      <th>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1</td>
                      <td>
                        <img
                          src={userImg}
                          width="35"
                          height="35"
                          alt="User"
                          className="wallet-main-img"
                        />
                      </td>
                      <td>jhanvi</td>
                      <td>76767757</td>
                      <td>felix</td>
                      <td>$ 0</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>
                        <img
                          src={userImg}
                          width="35"
                          height="35"
                          alt="User"
                          className="wallet-main-img"
                        />
                      </td>
                      <td>deepika</td>
                      <td>3543656</td>
                      <td>6th A</td>
                      <td>$ 128388</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>
                        <img
                          src={userImg}
                          width="35"
                          height="35"
                          alt="User"
                          className="wallet-main-img"
                        />
                      </td>
                      <td>jhanvi</td>
                      <td>76767757</td>
                      <td>felix</td>
                      <td>$ 0</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>
                        <img
                          src={userImg}
                          width="35"
                          height="35"
                          alt="User"
                          className="wallet-main-img"
                        />
                      </td>
                      <td>jhanvi</td>
                      <td>76767757</td>
                      <td>felix</td>
                      <td>$ 0</td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>
                        <img
                          src={userImg}
                          width="35"
                          height="35"
                          alt="User"
                          className="wallet-main-img"
                        />
                      </td>
                      <td>jhanvi</td>
                      <td>76767757</td>
                      <td>felix</td>
                      <td>$ 0</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Cashless_Balance_Report;
